import { render } from "./page15.vue?vue&type=template&id=242df80f&scoped=true"
import script from "./page15.vue?vue&type=script&lang=js"
export * from "./page15.vue?vue&type=script&lang=js"

import "./page15.vue?vue&type=style&index=0&id=242df80f&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242df80f"]])

export default __exports__